import Config from "@/const/Config";
import { BaseApi } from "@/api/BaseApi";
import { SyuugyouJoukenMeijisyo, SyuugyouJoukenMeijisyoRes } from "@/types/SyuugyouJoukenMeijisyo";
import { isNull } from "lodash";

export class SyuugyouJoukenMeijisyoApi extends BaseApi {
  /**
   * 雇用契約IDを指定して就業条件明示書を取得します
   * @returns システム上の全ての就業場所一覧
   */
  public async findByKoyouKeiyakuId(koyouKeiyakuId: number) {
    try {
      const res = await this.post<SyuugyouJoukenMeijisyoRes>(Config.API_URL + '/koyoukeiyaku/meijisyo/find_by_koyou_keiyaku_id', { koyouKeiyakuId });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 明示書の作成
   * @returns 当該ユーザーの就業場所一覧
   */
  public async create(req: SyuugyouJoukenMeijisyo) {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/koyoukeiyaku/meijisyo/create', { meijisyo: req });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 明示書の更新
   * @returns 当該ユーザーの就業場所一覧
   */
  public async update(req: SyuugyouJoukenMeijisyo) {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/koyoukeiyaku/meijisyo/update', { meijisyo: req });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }
}
